import { request } from "../request";


/**
 * 获取阿里云oss token
 */
export const getAliyunOssToken = () => {
    return request<{
        accessid: string;
        domain: string;
        policy: string;
        signature: string;
        host: string;
        callback: string;
        expire: string;
        dir: string;
    }>({
        url: "/pino_service_api/aliyunOss/getAliyunOssToken",
        method: "post",
        data: {
            data: {},
        },
        isAuth: true,
        isEncryption: true
    });
};
